<template>
  <v-dialog v-model="show_modal" persistent max-width="500">
    <v-card>
      <v-card-title>
        {{ $t("officer.config_individual_tuition_fee") }} ({{
          $t("config_academic.delete")
        }}) <br />
        {{ level == 1 ? "ระดับปริญญาตรี" : "ระดับบัณฑิตศึกษา (4+1, โท, เอก)" }}
      </v-card-title>
      <v-card-text>
        {{ $t("config_academic.confirm_delete") }}
        รหัสนักศึกษา {{ to_delete_item.student_id }}
        {{
          `${to_delete_item.std_info.prename_th}${to_delete_item.std_info.name_th} ${to_delete_item.std_info.surname_th}`
        }}
        <br />
        ปีการศึกษา {{ semester }}/{{ year }} หรือไม่ ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="delete_modal()">
          {{ $t("config_academic.confirm") }}</v-btn
        >
        <v-btn color="error" dark @click="show_modal = false">{{
          $t("config_academic.cancel")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ConfigProvider from "@/services/config.provider";
const configService = new ConfigProvider();

export default {
  name: "ConfigIndividualTuitionFeeDeleteDialog",

  props: {
    toggle_loading: Function,
    fetch_data: Function,
  },

  data: () => ({
    show_modal: false,
    level: null,
    semester: null,
    year: null,
    to_delete_item: {
      student_id: null,
    },
  }),

  computed: {},

  methods: {
    open_delete_modal: function (
      selected_level,
      selected_year,
      selected_semester,
      item
    ) {
      this.level = selected_level;
      this.year = selected_year;
      this.semester = selected_semester;
      this.to_delete_item = item;
      this.show_modal = true;
    },

    delete_modal: async function () {
      this.toggle_loading(true);
      let response = await configService
        .deleteIndividualTuitionFee({
          year: this.year,
          semester: this.semester,
          level: this.level,
          student_id: this.to_delete_item.student_id,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.toggle_loading(false);
        });
      this.show_modal = false;
      this.fetch_data();
      if (response && response.status)
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      else {
        this.$toasted.error(this.$t("toasted.cannot_delete"), {
          duration: 0,
        });
      }
    },
  },
};
</script>
